import { render, staticRenderFns } from "./chargeUnit.vue?vue&type=template&id=42434c5d&"
import script from "./chargeUnit.vue?vue&type=script&lang=js&"
export * from "./chargeUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42434c5d')) {
      api.createRecord('42434c5d', component.options)
    } else {
      api.reload('42434c5d', component.options)
    }
    module.hot.accept("./chargeUnit.vue?vue&type=template&id=42434c5d&", function () {
      api.rerender('42434c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/chargeUnit.vue"
export default component.exports